import { useState } from "react"
import { Modal, Text, Button, Stack, Title } from "@mantine/core"
import classes from "./BrandSelectorModal.module.css"
import { BrandSwitch } from "../BrandSwitch/BrandSwitch"
import { Brand } from "@utils/constants.util"
import { AEMComponentMapper, AEMPageType } from "@AEM/models/AEMPage.model"
import { useAEMComponentData } from "@AEM/AEMContentLoader"
import { eventTrackingItems } from "@utils/eventTracking"

interface BrandSelectorModalProps {
	opened: boolean
	onClose: () => void
	onSelect: (brand: Brand) => void
	brands: Brand[]
	isArchived?: boolean
}

export function BrandSelectorModal({
	opened,
	onClose,
	brands,
	onSelect,
	isArchived = false
}: BrandSelectorModalProps) {
	const { componentData } = useAEMComponentData(
		AEMPageType.DICTIONARY,
		AEMComponentMapper.APP_DICTIONARY
	)
	const [selectedBrand, setSelectedBrand] = useState<Brand | null>(null)

	const handleContinue = () => {
		if (selectedBrand) {
			onSelect(selectedBrand)
			onClose()
		}

		eventTrackingItems({
			event_name: "click",
			link_url: "",
			category: isArchived ? "archive promotions" : "feature promotions",
			interactionType: isArchived
				? "archive offers brand click"
				: "feature offers card click",
			navLinkText: componentData?.brandModalContinue ?? "",
			box_filter: selectedBrand ?? ""
		})
	}

	return (
		componentData && (
			<Modal
				opened={opened}
				onClose={onClose}
				centered
				classNames={{
					header: classes.header,
					title: classes.title,
					body: classes.body
				}}
			>
				<Stack align="center" gap="xl" justify="center" mb="xl">
					<Title className={classes.title} size="h5">
						{componentData.brandModalHeading}
					</Title>
					<Text size="sm" ta="center">
						{componentData.brandModalDescription}
					</Text>
					<BrandSwitch
						small={true}
						onSwitch={setSelectedBrand}
						availableBrands={brands}
					/>
					<Button
						size="lg"
						className={classes.continueButton}
						onClick={handleContinue}
						disabled={!selectedBrand}
					>
						{componentData.brandModalContinue}
					</Button>
				</Stack>
			</Modal>
		)
	)
}
